import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/components/View';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GenericNoContentDueToFilteringError = ({
  headingI18n,
  subtitleI18n,
  resetLink,
  onReset
}) => /*#__PURE__*/_jsxs(View, {
  "data-test-id": "no-content-error",
  marginBlock: "1000",
  role: "alert",
  textAlign: "center",
  children: [/*#__PURE__*/_jsx(Pictogram, {
    inlineSize: "100%",
    marginBlockEnd: "600",
    name: "EmptyStateSearch"
  }), /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.${headingI18n}`
    })
  }), /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.common.${subtitleI18n}`
    }), /*#__PURE__*/_jsx("br", {}), resetLink && /*#__PURE__*/_jsx(RouterLink, {
      "data-test-id": "clear-all-filters",
      onClick: onReset,
      to: resetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyErrors.filters.common.clearFilters"
      })
    })]
  })]
});
export default GenericNoContentDueToFilteringError;